<template>
  <div class="more-mobile">
    <app-header-container>
      {{ $t('components.Menu.more') }}
    </app-header-container>

    <div v-for="(item, index) of sections" :key="`${index}-${item.name}`" class="reset-indent">
      <a href="#" @click.prevent="handleClick(index)" class="more-mobile__item set-indent py-05 text-color-black d-flex align-center text--small text--medium">
        <div class="menu__item-icon heading-3 mr-2" :class="`${item.icon} ${item.iconClass}`"></div>
        <div>{{ item.label }}</div>
      </a>

      <div class="divider"></div>
    </div>

    <v-modal
      v-model="showModal"
      handle-click-bg
      full
      position="bottom"
      block-scroll
      animation="slide-up"
      min-width="50rem"
    >
      <template #header v-if="activeIndex !== null">
        {{ sections[activeIndex].label }}
      </template>

      <div v-if="activeIndex !== null">
        <component :is="sections[activeIndex].component" reset-indent></component>
      </div>

      <template #footer v-if="activeIndex !== null && sections[activeIndex].action">
        <component :is="sections[activeIndex].action"></component>
      </template>
    </v-modal>
  </div>
</template>

<script>
import vModal from '@/ui/modals/vModal'
import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'

import AddReferral from '@/components/AddReferral'

import screen from '@/mixins/screen'
import { ShowPromoMaterials, ShowRegisteredUsers, ShowBills, ShowAddUserControl } from '@/mixins/displayRules'

import Documents from './Documents'
import Referrals from './Referrals'
import PromoMaterials from './PromoMaterials'
import Bills from './Bills'

// import Goldshop from './Goldshop'
// import Api from './Api'

export default {
  name: 'more',

  components: {
    AppHeaderContainer,
    vModal
  },

  mixins: [screen, ShowRegisteredUsers, ShowPromoMaterials, ShowBills, ShowAddUserControl],

  watch: {
    showModal (val) {
      if (!val) {
        this.$nextTick(() => {
          this.activeIndex = null
          this.$router.push({
            name: this.$route.name,
            query: {}
          })
        })
      }
    },

    async 'screen.breakPoint.tabPort' (val) {
      if (val && this.activeIndex === null) {
        await this.$router.push({
          name: 'dashboard'
        })
      }
    }
  },

  methods: {
    handleClick (index) {
      this.activeIndex = index
      this.$nextTick(() => {
        this.showModal = true

        if (this.sections[this.activeIndex].name === this.$route.query.section) {
          return
        }
        this.$router.push({
          name: this.$route.name,
          query: {
            section: this.sections[this.activeIndex].name
          }
        })
      })
    }
  },

  data () {
    return {
      activeIndex: null,
      showModal: false
    }
  },

  computed: {
    sections () {
      const sections = [
        // {
        //   icon: 'icon-logo_swpl',
        //   label: 'SWITPLANET',
        //   name: 'switplanet',
        //   iconClass: 'menu__item-icon--green',
        //   component: Switplanet
        // },
        // {
        //   icon: 'icon-dollar',
        //   label: 'Gold Shop',
        //   name: 'goldshop',
        //   iconClass: '',
        //   component: Goldshop
        // },
        {
          icon: 'icon-invoice',
          label: this.$i18n.t('components.Menu.documents'),
          name: 'documents',
          iconClass: '',
          component: Documents
        },
        {
          icon: 'icon-promo_mat',
          label: this.$i18n.t('components.Menu.promoMaterials'),
          name: 'promo-materials',
          iconClass: '',
          component: PromoMaterials,
          show: this.ShowPromoMaterials
        },
        // {
        //   icon: 'icon-settings',
        //   label: this.$t('views.Dashboard.Documentation.menuName'),
        //   name: 'api',
        //   iconClass: '',
        //   component: Api
        // },
        {
          icon: 'icon-users',
          label: this.$i18n.t('views.Referrals.title'),
          name: 'referrals',
          iconClass: '',
          component: Referrals,
          action: this.ShowAddUserControl ? AddReferral : null,
          show: this.ShowRegisteredUsers
        },
        {
          icon: 'icon-receipt',
          label: this.$t('components.Menu.bills'),
          name: 'bills',
          component: Bills,
          iconClass: '',
          show: this.ShowBills && this.profile && this.profile.prepayment
        }
      ]

      return sections.filter(s => typeof s.show === 'undefined' || s.show)
    }
  },

  beforeMount () {
    const activeIndex = this.sections.findIndex(item => {
      return item.name === this.$route.query.section
    })

    if (activeIndex > -1) {
      this.activeIndex = activeIndex
      this.showModal = true
    } else if (this.screen.breakPoint.tabPort) {
      this.$router.push({
        name: 'dashboard'
      })
    }
  }
}
</script>

<style lang="scss">
  .more-mobile {
    &__item {}
  }
</style>
